import { render, staticRenderFns } from "./ThanhToan.vue?vue&type=template&id=b889d946&scoped=true&"
import script from "./ThanhToan.vue?vue&type=script&lang=js&"
export * from "./ThanhToan.vue?vue&type=script&lang=js&"
import style0 from "./ThanhToan.vue?vue&type=style&index=0&id=b889d946&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b889d946",
  null
  
)

export default component.exports